import { COMPANY } from "@/i18n/translations";

// Each legal page: { title, sections: [{h, p}] } per language
export const LEGAL = {
  mentions: {
    fr: {
      title: "Mentions légales",
      sections: [
        { h: "Éditeur du site", p: `Le présent site est édité par ${COMPANY.name}, ${COMPANY.form} au capital de ${COMPANY.capital}. Siège social : ${COMPANY.address}. ${COMPANY.rcs}. SIREN : ${COMPANY.siren}. EUID : ${COMPANY.euid}.` },
        { h: "Directeur de la publication", p: `${COMPANY.president}.` },
        { h: "Contact", p: `E-mail : ${COMPANY.email}.` },
        { h: "Hébergeur", p: "Le site est hébergé sur une infrastructure cloud située dans l'Union européenne." },
        { h: "Propriété intellectuelle", p: "L'ensemble des contenus (textes, visuels, logo, images de véhicules) est la propriété exclusive de CEA30 ou de ses partenaires. Toute reproduction est interdite sans autorisation." },
        { h: "Greffe", p: `${COMPANY.greffe}.` },
      ],
    },
    en: {
      title: "Legal notice",
      sections: [
        { h: "Site publisher", p: `This website is published by ${COMPANY.name}, single-shareholder simplified joint-stock company with a capital of ${COMPANY.capital}. Registered office: ${COMPANY.address}. ${COMPANY.rcs}. SIREN: ${COMPANY.siren}. EUID: ${COMPANY.euid}.` },
        { h: "Publication director", p: `${COMPANY.president}.` },
        { h: "Contact", p: `Email: ${COMPANY.email}.` },
        { h: "Hosting", p: "The site is hosted on cloud infrastructure located within the European Union." },
        { h: "Intellectual property", p: "All content (text, visuals, logo, vehicle images) is the exclusive property of CEA30 or its partners. Any reproduction is prohibited without authorization." },
        { h: "Registry", p: `${COMPANY.greffe}.` },
      ],
    },
  },
  cgv: {
    fr: {
      title: "Conditions Générales de Vente",
      sections: [
        { h: "1. Objet", p: "Les présentes CGV régissent les prestations de location de véhicules sans chauffeur, la vente et la location d'équipements automobiles proposées par CEA30." },
        { h: "2. Prix", p: "Les prix sont indiqués en euros toutes taxes comprises (TVA 20 %). CEA30 se réserve le droit de modifier ses tarifs à tout moment." },
        { h: "3. Commande & paiement", p: "Le paiement s'effectue en ligne de manière sécurisée via Stripe. CEA30 n'a aucun accès aux données bancaires du client." },
        { h: "4. Location", p: "La location d'un véhicule est soumise à la présentation d'un permis de conduire valide et d'une pièce d'identité. Un dépôt de garantie peut être demandé." },
        { h: "5. Rétractation", p: "Conformément à l'article L221-18 du Code de la consommation, le client dispose d'un délai de 14 jours pour se rétracter sur l'achat d'équipements." },
        { h: "6. Responsabilité", p: "CEA30 ne saurait être tenue responsable d'un usage non conforme des véhicules ou équipements loués." },
        { h: "7. Droit applicable", p: "Les présentes CGV sont soumises au droit français. Tout litige relève des tribunaux compétents du siège social." },
      ],
    },
    en: {
      title: "Terms & Conditions",
      sections: [
        { h: "1. Purpose", p: "These terms govern the self-drive vehicle rental services, sale and rental of automotive equipment offered by CEA30." },
        { h: "2. Prices", p: "Prices are shown in euros, inclusive of all taxes (VAT 20%). CEA30 reserves the right to change its prices at any time." },
        { h: "3. Order & payment", p: "Payment is made securely online via Stripe. CEA30 has no access to the customer's banking data." },
        { h: "4. Rental", p: "Vehicle rental is subject to a valid driving licence and ID. A security deposit may be required." },
        { h: "5. Withdrawal", p: "In accordance with article L221-18 of the French Consumer Code, the customer has 14 days to withdraw from an equipment purchase." },
        { h: "6. Liability", p: "CEA30 cannot be held liable for improper use of rented vehicles or equipment." },
        { h: "7. Applicable law", p: "These terms are governed by French law. Any dispute falls under the competent courts of the registered office." },
      ],
    },
  },
  confidentialite: {
    fr: {
      title: "Politique de confidentialité (RGPD)",
      sections: [
        { h: "Responsable de traitement", p: `${COMPANY.name}, ${COMPANY.address}.` },
        { h: "Données collectées", p: "Nom, e-mail, téléphone, société et détails des demandes. Les données de paiement sont traitées exclusivement par Stripe." },
        { h: "Finalités", p: "Gestion des commandes, traitement des demandes de devis et service après-vente." },
        { h: "Vos droits", p: `Vous disposez d'un droit d'accès, de rectification, d'effacement, de portabilité et d'opposition. Pour l'exercer, contactez ${COMPANY.email}.` },
      ],
    },
    en: {
      title: "Privacy policy (GDPR)",
      sections: [
        { h: "Data controller", p: `${COMPANY.name}, ${COMPANY.address}.` },
        { h: "Data collected", p: "Name, email, phone, company and request details. Payment data is processed exclusively by Stripe." },
        { h: "Purposes", p: "Order management, quote request processing and after-sales service." },
        { h: "Your rights", p: `You have the right to access, rectify, erase, port and object. To exercise it, contact ${COMPANY.email}.` },
      ],
    },
  },
  cookies: {
    fr: {
      title: "Politique cookies",
      sections: [
        { h: "Cookies utilisés", p: "Le site utilise uniquement des cookies techniques nécessaires à son fonctionnement (préférence de langue et contenu du panier)." },
        { h: "Cookies publicitaires", p: "Aucun cookie publicitaire ou de suivi n'est déposé sans votre consentement." },
        { h: "Gestion", p: "Vous pouvez gérer ou supprimer les cookies à tout moment via les paramètres de votre navigateur." },
      ],
    },
    en: {
      title: "Cookie policy",
      sections: [
        { h: "Cookies used", p: "The site only uses technical cookies necessary for its operation (language preference and cart content)." },
        { h: "Advertising cookies", p: "No advertising or tracking cookie is placed without your consent." },
        { h: "Management", p: "You can manage or delete cookies at any time via your browser settings." },
      ],
    },
  },
};
